<div class="calendar-container">
  <div class="calendar-nav-wrapper">
    <button (click)="prevMonth()">‹</button>
    <div class="calendar-month">{{ currentMonth | date: 'MMMM yyyy' }}</div>
    <button (click)="nextMonth()">›</button>
  </div>


  <div class="weekdays">
    <div *ngFor="let day of weekDays">{{ day }}</div>
  </div>

  <div class="weeks">
    <div class="week" *ngFor="let week of weeks">
      <div
        class="day"
        *ngFor="let day of week"
        [class.outside]="!day.isCurrentMonth"
        [class.today]="isToday(day.date)"
        [class.holiday]="isHoliday(day.date)"
      >
        <div class="date-number">{{ day.date.getDate() }}</div>
        <div class="holiday-label" *ngIf="isHoliday(day.date)">
          {{ getHolidayLabel(day.date) }}
        </div>
      </div>
    </div>
  </div>
</div>
